module.exports = __webpack_public_path__ + "static/media/bg-image.d9936372.png";